export default "__VITE_ASSET__ea7edd62__"